import { Boundaries } from "@planzone/core";
import { project } from "@planzone/dto";
import { Event, events } from "@planzone/events";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { reduceProject } from "../../common/project";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = [];

function handleRequest(
  state: State,
  id: Boundaries["retrieveProject"]["request"],
): State {
  return [...state, { request: setRequestStateToPending(), id, project }];
}

function handleSuccess(
  state: State,
  project: Boundaries["retrieveProject"]["success"],
): State {
  return state.map((res) =>
    res.id === project.uuid
      ? { ...res, request: setRequestStateToSuccess(), project }
      : res,
  );
}

function handleFailure(
  state: State,
  id: Boundaries["retrieveProject"]["failure"],
): State {
  return state.map((res) =>
    res.id === id ? { ...res, request: setRequestStateToFailure() } : res,
  );
}

function handleValidateTimeSheetUpToDate(
  state: State,
  { project, date }: Boundaries["validateTimeRecordsUpToDate"]["failure"],
): State {
  return state.map((res) =>
    res.id === project.uuid
      ? { ...res, project: { ...res.project, integratedAt: date } }
      : res,
  );
}

function propagateEvent(state = initialState, event: Event): State {
  return state.map((req) => ({
    ...req,
    project: reduceProject(req.project, event),
  }));
}

const reduceState = resetState(
  initialState,
  createStateReducer(
    initialState,
    {
      [events.retrieveProjectRequested]: handleRequest,
      [events.retrieveProjectSucceeded]: handleSuccess,
      [events.retrieveProjectFailed]: handleFailure,
      [events.validateTimeRecordsUpToDateSucceeded]:
        handleValidateTimeSheetUpToDate,
    },
    propagateEvent,
  ),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
